// extracted by mini-css-extract-plugin
export default {"rowPt":"forgot-password_rowPt__FKbyV","Background":"forgot-password_Background__gdoCN"};